import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserHttpService } from '../services/user.http.service';

export const authGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const httpService = inject(UserHttpService);
    const isVerified = (user: any) => {
        const verified = user?.verified;
        return verified === true || verified === 'true' || verified === 1 || verified === '1';
    };
    const isVerifyRoute = state.url.startsWith('/verify');

    const currentUser = httpService.currentUser();
    if (currentUser) {
        if (isVerifyRoute && isVerified(currentUser)) {
            return router.createUrlTree(['/dashboard']);
        }
        return true;
    }

    return httpService.getCurrentUser().pipe(
        map((user) => {
            if (user) {
                if (isVerifyRoute && isVerified(user)) {
                    return router.createUrlTree(['/dashboard']);
                }
                return true;
            }
            return router.createUrlTree(['/login']);
        }),
        catchError(() => {
            httpService.setCurrentUser(null);
            return of(router.createUrlTree(['/login']));
        }),
    );
};
